const apiKey = process.env.NEXT_PUBLIC_BUTTER_CMS_API_KEY || "";

export async function getLandingPage(page, locale) {
  const url = `https://api.buttercms.com/v2/pages/*/${page}/?auth_token=${apiKey}&locale=${locale}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Error fetching landing page: ${response.statusText}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("Error fetching landing page:", error);
    return null;
  }
}

export async function getFilteredWeddingProducts(locale, section) {
  const url = `https://api.buttercms.com/v2/content/wedding_products/?auth_token=${apiKey}&locale=${locale}&fields.section=${section}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Error fetching landing page: ${response.statusText}`);
    }

    const result = await response.json();
    return result.data.wedding_products;
  } catch (error) {
    console.error("Error fetching wedding products:", error);
    return null;
  }
}

export async function getFilteredWeddingBulkProducts(locale, section) {
  const url = `https://api.buttercms.com/v2/content/bulk_florals-552fd440-964c-4c37-88ff-d9e207de/?auth_token=${apiKey}&locale=${locale}&fields.section=${section}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Error fetching landing page: ${response.statusText}`);
    }

    const result = await response.json();
    return result.data["bulk_florals-552fd440-964c-4c37-88ff-d9e207de"];
  } catch (error) {
    console.error("Error fetching wedding products:", error);
    return null;
  }
}

export async function getSeasonalWeddingProducts(locale) {
  const url = `https://api.buttercms.com/v2/content/wedding_products/?auth_token=${apiKey}&locale=${locale}&fields.line=seasonal`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Error fetching landing page: ${response.statusText}`);
    }

    const result = await response.json();
    return result.data.wedding_products;
  } catch (error) {
    console.error("Error fetching wedding products:", error);
    return null;
  }
}

export async function getCityWeddingPageData() {
  const [cityPage, mainPage] = await Promise.all([
    getLandingPage("wedding-city-landing", "en-ca"),
    getLandingPage("wedding-landing", "en-ca")
  ]);

  if (!cityPage || !mainPage) return null;

  return {
    wedding_review_section: cityPage.fields.wedding_review_section,
    seasonal_bouquets: cityPage.fields.seasonal_bouquets,
    quote_tool_section: mainPage.fields.quote_tool_section,
  };
}

export async function getFooter(locale) {
  const url = `https://api.buttercms.com/v2/content/navigation_menu?auth_token=${apiKey}&locale=${locale}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Error fetching landing page: ${response.statusText}`);
    }

    const result = await response.json();
    return result.data.navigation_menu[0];
  } catch (error) {
    console.error("Error fetching landing page:", error);
    return null;
  }
}
